import React from "react";
import { MobileSheet } from "../calendar/CalendarView/mobile/sheets/MobileSheet";
import { AlertsHeader, useAlertsRefresh } from "./AlertsPanel";
import { AlertsList } from "./AlertsList";

interface AlertsSheetProps {
  opened: boolean;
  onClose: () => void;
}

/** Mobile Alerts: the same list in the calendar's bottom sheet. */
export const AlertsSheet: React.FC<AlertsSheetProps> = ({
  opened,
  onClose,
}) => {
  useAlertsRefresh(opened);
  return (
    <MobileSheet
      opened={opened}
      onClose={onClose}
      title="Alerts"
      header={<AlertsHeader />}
      data-testid="alerts-sheet"
    >
      <AlertsList onNavigate={onClose} />
    </MobileSheet>
  );
};
